/** Lugna brand tokens carried over from app-planner-wardrobe. */
export const lugna = {
    id: 'lugna',
    name: 'Lugna',
    legalName: 'Lugna',
    websiteUrl: {
        au: 'https://www.lugna.com.au',
        nz: 'https://www.lugna.co.nz',
    },
    supportEmail: 'support@lugna.com.au',
    fonts: {
        heading: 'NimbusSansLBold, Arial, sans-serif',
        body: 'NimbusSansLRegular, Arial, sans-serif',
    },
    colors: {
        primary: {
            50: '#EDF0F3',
            100: '#D1D8E0',
            200: '#B5C0CD',
            300: '#99A8BA',
            400: '#7D90A7',
            500: '#415569',
            600: '#344455',
            700: '#273341',
            800: '#1A222C',
            900: '#0D1118',
        },
        primaryForeground: '#FFFFFF',
        primaryStrongForeground: '#FFFFFF',
        progress: '#415569',
        accent: '#259596',
        headerBg: '#415569',
        footerBg: '#415569',
        plannerPageBg: '#F2F2F2',
        pageBg: '#F2F2F2',
        text: '#1A222C',
    },
    logos: {
        header: '/brands/lugna/logo-header.svg',
        footer: '/brands/lugna/logo-footer.svg',
        favicon: '/brands/lugna/favicon.svg',
        email: '/brands/lugna/logo-email.svg',
    },
    copy: {
        tagline: 'Storage made simple',
        footerLine: 'Lugna — designed and made in Australia',
        emailSignoff: 'The Lugna team',
    },
    social: {
        facebook: 'https://www.facebook.com/lugna',
        instagram: 'https://www.instagram.com/lugna',
    },
};
//# sourceMappingURL=lugna.js.map